export function isLaunchedAsInstalledPwa(): boolean {
  const standaloneMode =
    globalThis.matchMedia?.('(display-mode: standalone)').matches ?? false
  const iosStandalone =
    'standalone' in globalThis.navigator && globalThis.navigator.standalone === true

  return standaloneMode || iosStandalone
}

export function registerPwa(): void {
  if (!('serviceWorker' in navigator)) return
  if (globalThis.location.pathname.startsWith('/helpdesk')) return

  const manifest = document.createElement('link')
  manifest.rel = 'manifest'
  manifest.href = '/customerportal/manifest.webmanifest'
  document.head.appendChild(manifest)

  const themeColor = document.createElement('meta')
  themeColor.name = 'theme-color'
  themeColor.content = globalThis.location.hostname.includes('zurich')
    ? '#2167ae'
    : '#003264'
  document.head.appendChild(themeColor)

  navigator.serviceWorker
    .register('/customerportal/service-worker.js', { scope: '/customerportal/' })
    .catch((error) => {
      console.warn(
        'PWA-Service-Worker konnte nicht registriert werden.',
        error instanceof Error ? error.message : 'unbekannter Fehler'
      )
    })
}
